module.exports = __webpack_public_path__ + "static/media/question.1083cca0.svg";